/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from 'react';
import { FLink, Button, LoadingIndicator, FModal, Icons } from '@components';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { SimularBeneficioService } from '@services/simular-beneficio';
import { mdiAlertCircleOutline } from '@mdi/js';
import { ResultadoVitalicio } from './utils/resultadoVitalicio';
import { ID_VITALICIO } from '../../../Beneficios/components/Renda/utils';
import { ResultadoConjugado } from './utils/resultadoConjugado';
import { CONVERSAO_BENEFICIOS } from '../../../../common/utils/paths';
import { calculaIdade } from '../../../../common/utils';
import { obterFormulariosRequest } from '../../../../store/modules/requerimento/actions';

const simularBeneficioService = new SimularBeneficioService();

const REFERENCIA_BENEFICIARIOS_RCM =
  'RequerimentoAvaliacaoInscricaoAlteracaoBeneficiosRCM';

export const ResultadoConversaoBeneficio = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dadosRenda = useSelector((state) => state.simulacaoBeneficio);
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [erroSimulacao, setErroSimulacao] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [linkPDF, setLinkPDF] = useState('');
  const nomesBeneficiarios = dadosRenda.beneficiariosChecked.map((b) => b.nome);

  const { allForms: formularios, allFormsRequestDone } = useSelector(
    (state) => state.requerimento
  );

  const formularioBeneficiariosRCM = useMemo(
    () =>
      formularios.find((f) => f.referencia === REFERENCIA_BENEFICIARIOS_RCM),
    [formularios]
  );

  const isBeneficiariosRCMHabilitado =
    formularioBeneficiariosRCM?.habilitado ?? false;

  useEffect(() => {
    if (!allFormsRequestDone) {
      dispatch(obterFormulariosRequest());
    }
  }, [allFormsRequestDone, dispatch]);

  const handleIrParaRequerimento = () => {
    if (isBeneficiariosRCMHabilitado && formularioBeneficiariosRCM) {
      navigate(`/requerimentos/novo/${formularioBeneficiariosRCM.destino}`);
    }
  };
  const [resultadoSimulacao, setResultadoSimulacao] = useState({});

  useEffect(() => {
    const simularConversaoBeneficios = async () => {
      const percentualSaldo =
        dadosRenda.percentualRendaMensal === ''
          ? 0
          : parseFloat(dadosRenda.percentualRendaMensal);

      const resultadoSimulacaoService =
        await simularBeneficioService.postConversaoParticipante({
          matricula: user.matricula,
          opcaoRenda: dadosRenda.tipoRendaMensal,
          percentualSaldo,
          percentualRcm: dadosRenda.percentualrcm,
          percentualRendaVitalicia: dadosRenda.percentualSaldoVitalicio,
          codigosBeneficiario: dadosRenda.beneficiariosChecked.map((b) => b.id),
        });

      if (resultadoSimulacaoService.CodErro) {
        setErroSimulacao(resultadoSimulacaoService.MsgErro);
        setModalIsOpen(true);
      }

      const obterLinkRelatorio =
        await simularBeneficioService.postLinkConversaoBeneficios({
          matricula: user.matricula,
          nome: user.nome,
          idade: calculaIdade(user.dadosPessoais.nascimento),
          token: user.token,
          opcaoRenda: dadosRenda.tipoRendaMensal,
          percentualSaldo,
          percentualRcm: dadosRenda.percentualrcm,
          percentualRendaVitalicia: dadosRenda.percentualSaldoVitalicio,
          codigosBeneficiario: dadosRenda.beneficiariosChecked.map((b) => b.id),
          beneficiarios: dadosRenda.beneficiariosChecked.map((b) => b),
        });

      setResultadoSimulacao(resultadoSimulacaoService);
      setLinkPDF(`data:application/pdf;base64,${obterLinkRelatorio}`);
    };

    const recuperaValoresResultado = async () => {
      setLoading(true);
      await simularConversaoBeneficios();
      setLoading(false);
    };

    recuperaValoresResultado();
  }, [user.token, user.nome, user.matricula]);

  return !loading ? (
    <div className="card">
      {!modalIsOpen ? (
        <>
          <div className="card-body pb-0">
            <FLink
              className="justify-content-start mb-32"
              iconLeft="icon-arrow_back"
              onClick={() => navigate(-1)}
            >
              voltar
            </FLink>

            <h3 className="ts-20 fw-bold mb-2">Resultado da simulação</h3>
            <p className="ts-14 text-muted">
              O resultado exibido é mera simulação de cálculo, não existindo
              qualquer garantia do valor de benefício apresentado.
            </p>

            {dadosRenda.tipoRendaMensal === parseInt(ID_VITALICIO, 10) ? (
              <ResultadoVitalicio
                PercentualRCM={dadosRenda.percentualrcm}
                ResultadoSimulacao={resultadoSimulacao}
              />
            ) : (
              <ResultadoConjugado
                PercentualRCM={dadosRenda.percentualrcm}
                ResultadoSimulacao={resultadoSimulacao}
                PercentualSaldoVitalicio={dadosRenda.percentualSaldoVitalicio}
                PercentualRendaMensal={dadosRenda.percentualRendaMensal}
              />
            )}

            <div
              className="card shadow-sm border-0 p-4 mb-3"
              style={{ borderRadius: '12px' }}
            >
              <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
                <div>
                  <h3 className="fw-bold mb-2">
                    Alteração de Beneficiários (RCM)
                  </h3>
                  <p className="mb-0 text-muted">
                    Para alterar os beneficiários, favor preencher o
                    requerimento de Avaliação para Inscrição / Alteração de
                    Beneficiários para Renda Continuada por Morte (RCM),
                    clicando no botão ao lado
                  </p>
                </div>
                <div className="d-flex flex-column align-items-center flex-shrink-0">
                  <Button
                    transparent
                    color="orange"
                    onClick={handleIrParaRequerimento}
                    disabled={loading || !isBeneficiariosRCMHabilitado}
                  >
                    Ir para Requerimento
                  </Button>
                  {!isBeneficiariosRCMHabilitado && allFormsRequestDone && (
                    <div
                      className="d-flex align-items-start gap-2 mt-2 p-2"
                      style={{
                        backgroundColor: '#fff3e0',
                        borderRadius: '8px',
                        maxWidth: '280px',
                      }}
                    >
                      <Icons
                        path="warning"
                        size={1.2}
                        style={{ color: '#f9a825', flexShrink: 0 }}
                      />
                      <span
                        className="ts-12 fw-bold"
                        style={{ color: '#f9a825' }}
                      >
                        Para criar um novo requerimento desse tipo é necessário
                        cancelar o requerimento anterior em andamento.
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <p className="is-mobile ts-14 text-black">
              {nomesBeneficiarios.length === 0
                ? 'Não foram considerados beneficiários nessa simulação.'
                : `Beneficiários considerados: ${nomesBeneficiarios.join(
                    ', '
                  )}`}
            </p>
            <p className="is-desktop ts-14 text-muted">
              {nomesBeneficiarios.length === 0
                ? 'Não foram considerados beneficiários nessa simulação.'
                : `Beneficiários considerados: ${nomesBeneficiarios.join(
                    ', '
                  )}`}
            </p>
          </div>
          <div className="card-footer">
            <hr className="my-32" />
            <div className="row">
              <div className="d-block d-md-flex align-items-center ms-auto col-12 col-md-6">
                <Button
                  transparent
                  color="orange"
                  className="mb-3 mb-md-0"
                  onClick={() => navigate(CONVERSAO_BENEFICIOS)}
                >
                  Simular outro valor
                </Button>
                <a
                  href={linkPDF}
                  rel="noreferrer"
                  target="_blank"
                  download="pdfTitle"
                  title="Clique para baixar o pdf do protocolo"
                  className="ms-0 ms-md-3 aButton"
                >
                  Visualizar
                </a>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="card">
          <div className="card-body">
            <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
              <Button
                className="justify-content-center mb-32"
                transparent
                color="orange"
                icon="arrow_back"
                onClick={() => navigate(CONVERSAO_BENEFICIOS)}
              >
                Voltar
              </Button>
            </div>
          </div>
        </div>
      )}

      <FModal
        isOpen={modalIsOpen}
        close={false}
        onClose={() => setModalIsOpen(false)}
      >
        <Icons path={mdiAlertCircleOutline} color="var(--error)" size={2} />
        <h1 className="ts-20 fw-bold mb-1">{erroSimulacao}</h1>
        <Button
          className="mt-32"
          onClick={() => {
            navigate(CONVERSAO_BENEFICIOS);
          }}
        >
          Ok
        </Button>
      </FModal>
    </div>
  ) : (
    <LoadingIndicator />
  );
};
